// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_loader__\\+lRPl {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--color-accent);
}

.Loader_spinnerContainer__HKk2D {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-overlay);
  /* Semi-transparent background */
  z-index: 1000;
  /* Ensure it's above other elements */
}

.Loader_spinner__iDFIv {
  width: 50px;
  height: 50px;
  border: 5px solid var(--color-border);
  /* Light grey border */
  border-top: 5px solid var(--color-accent);
  /* Blue border */
  border-radius: 50%;
  animation: Loader_spin__E4RJ0 1s linear infinite;
  /* Correctly apply the spin animation */
}

.Loader_loadingText__URtw4 {
  margin-top: 10px;
  font-size: 18px;
  color: var(--color-text);
}

/* Keyframes for the spinning effect */
@keyframes Loader_spin__E4RJ0 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gDAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".loader {\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--color-accent);\n}\n\n.spinnerContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--color-overlay);\n  /* Semi-transparent background */\n  z-index: 1000;\n  /* Ensure it's above other elements */\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid var(--color-border);\n  /* Light grey border */\n  border-top: 5px solid var(--color-accent);\n  /* Blue border */\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  /* Correctly apply the spin animation */\n}\n\n.loadingText {\n  margin-top: 10px;\n  font-size: 18px;\n  color: var(--color-text);\n}\n\n/* Keyframes for the spinning effect */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `Loader_loader__+lRPl`,
	"spinnerContainer": `Loader_spinnerContainer__HKk2D`,
	"spinner": `Loader_spinner__iDFIv`,
	"spin": `Loader_spin__E4RJ0`,
	"loadingText": `Loader_loadingText__URtw4`
};
export default ___CSS_LOADER_EXPORT___;
